import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';
import Lazy from 'lazy.js';

import MobileHeader from '../../components/MobileHeader/MobileHeader';
import ImagePicker from '../../components/ImagePicker/ImagePicker';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';

import Input from 'react-bootstrap/lib/Input';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

import FormSection from '../../components/FormSection/FormSection';
import FormGroup from '../../components/FormGroup/FormGroup';

const Profile = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired,
		userRef: React.PropTypes.object
	},

    getInitialState() {
        return {
            birthday: this.context.userRef.val().birthday,
            firstname: this.context.userRef.val().firstname,
            lastname: this.context.userRef.val().lastname,
            gender: this.context.userRef.val().gender
        }
    },

    render() {
		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='profile'
				    title='Profile'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content bg-gray">
					<div className="profile-image-wrap">
						<ImagePicker/>
					</div>

					<FormSection>
						<FormGroup type="text" label="First name">
							<Input type="text" valueLink={this.userLinkState('firstname')}/>
						</FormGroup>
						<FormGroup
							type="text"
							label="Last name"
						>
							<Input type="text" valueLink={this.userLinkState('lastname')}/>
						</FormGroup>
					</FormSection>

					<FormSection>
						<FormGroup
							type="date"
						    label="Date of birth"
						>
							<Input type="date" valueLink={this.userLinkState('birthday')}/>
						</FormGroup>
						<FormGroup
							type="select"
							label="Gender"
						>
							<Input type="select" valueLink={this.userLinkState('gender')}>
								<option value="m">Male</option>
								<option value="f">Female</option>
							</Input>
						</FormGroup>
					</FormSection>

					<FormSection>
						<div className="ma-form-group ma-form-link-wrap">
							<TouchLink to="/profile/school" className="ma-form-link"><span className="link-text">School</span> <Glyphicon glyph="menu-right"/></TouchLink>
						</div>
						<div className="ma-form-group ma-form-link-wrap">
							<TouchLink to="/profile/password" className="ma-form-link"><span className="link-text">Password</span>  <Glyphicon glyph="menu-right"/></TouchLink>
						</div>
						<div className="ma-form-group ma-form-link-wrap">
							<TouchLink to="/profile/notifications" className="ma-form-link"><span className="link-text">Notifications</span>  <Glyphicon glyph="menu-right"/></TouchLink>
						</div>
						<div className="ma-form-group ma-form-link-wrap">
							<TouchLink to="/profile/payment" className="ma-form-link"><span className="link-text">Payment</span>  <Glyphicon glyph="menu-right"/></TouchLink>
						</div>
					</FormSection>

					<FormSection>
						<div className="ma-form-group ma-form-link-wrap">
							<TouchLink className="ma-form-link"><span className="link-text">Logout</span></TouchLink>
						</div>
					</FormSection>
				</div>
			</div>
		);
	},

	userLinkState(name) {
		return {
			value: this.state[name],
			requestChange: (newValue) => {
				this.setState({[name]: newValue});
                this.context.userRef.ref().child(name).set(newValue).then(
					null, window.alert
				);
			}
		}
	}
});

export default Profile;


/** WEBPACK FOOTER **
 ** ./src/screens/profile/Profile.js
 **/